import { useClaims } from '@auth/useClaims';
import type { CrmAdviseursGetAdviseursDto as Adviseur } from '@services/crm-internal/api';
import { useDomeinVerificatieGetDomeinen } from '@services/crm-public/orval-api/domein-verificatie/domein-verificatie';
import { computed, toValue, type MaybeRefOrGetter } from 'vue';

export function useDomeinen(
  adviseurnummer?: MaybeRefOrGetter<Adviseur['adviseurnummer'] | undefined>,
) {
  const claims = useClaims();

  return useDomeinVerificatieGetDomeinen(
    computed(() => ({
      adviseurnummer: toValue(adviseurnummer),
    })),
    {
      query: {
        enabled: () => !claims.value.isInternal || !!toValue(adviseurnummer),
      },
    },
  );
}
